module.exports = __webpack_public_path__ + "img/PEPTONASHIDROLIZADOS.929e0b30.png";